import { Component, Host, h, Element } from '@stencil/core';

export interface AhaCardDivider extends HTMLAhaCardDividerElement {}

/**
 * Starter component
 * @slot default - Contents of the default slot.
 */
@Component({
  tag: 'aha-card-divider',
  styleUrl: 'aha-card-divider.css',
  shadow: true,
})
export class AhaCardDivider {
  @Element() host!: HTMLAhaCardDividerElement;
  render() {
    return (
      <Host>
        <div>
          <hr />
        </div>
      </Host>
    );
  }
}
